import { put } from 'redux-saga/effects';
import appAction from '../actions/app';
import { editAppDataActionReturnType, getAppDataActionReturnType } from '../../types/actions/app';
import { appDataType } from '../../types/types';

// Persists edited appData and syncs Redux from storage.
export function* sagaEditAppData(action: editAppDataActionReturnType): any {
  try {
    if (action.isIntegration) {
      sessionStorage.setItem('appData', JSON.stringify(action.data));
    } else {
      localStorage.setItem('appData', JSON.stringify(action.data));
    }
    const appDataEditResponse = action.isIntegration
      ? sessionStorage.getItem('appData')
      : localStorage.getItem('appData');

    if (appDataEditResponse && appDataEditResponse.length > 0) {
      yield put(appAction.getAppData(JSON.parse(appDataEditResponse) as appDataType));
    }
    action.callback && action.callback();
  } catch {
    // Invalid stored appData; Redux state unchanged.
  }
}

// Loads appData from storage into Redux.
export function* sagaGetAppData(action: getAppDataActionReturnType): any {
  try {
    const appDataResponse = action.isIntegration ? sessionStorage.getItem('appData') : localStorage.getItem('appData');
    if (appDataResponse && appDataResponse.length > 0) {
      yield put(appAction.getAppData(JSON.parse(appDataResponse) as appDataType));
    }
  } catch {
    // Invalid stored appData; Redux state unchanged.
  }
}
